<template>
  <div class="mb-3 restaurant-regular shadow bg-white">
    <b-row class="m-0 justify-content-between h-100" >
      <b-col cols="7">
        <div class="mt-2 pb-5 pl-0 pl-md-2 ">
          <h4 class="text-start hover" @click="$router.push('/my/'+ url).catch(err => {})" v-if="url">{{name.substring(0,25)}}</h4>
          <p class="m-0 text-start hover" @click="$router.push('/my/'+ url).catch(err => {})">{{description}}</p>
          <b-row class="m-0 w-100 restaurant-open-times" >
            <p v-if="getOpeningTimes().first || getOpeningTimes().second"> <span> {{ getOpeningTimes().first }} </span> <span class="ml-3"> {{ getOpeningTimes().second }} </span></p>
            <p v-else>heute geschlossen</p>
          </b-row>
          <b-row class="m-0 w-100 restaurant-rating" >
            <div @click="openRatingModal()" class="w-75">
              <b-form-rating readonly class="hover  text-center" size="md" :no-border="true" variant="warning" v-model="getRating"></b-form-rating>
            </div>
            <p>({{ratings.length}})</p>
          </b-row>
          
        </div>
        <div class="restaurant-details linear-warning" @click="$router.push('/my/'+ id).catch(err => {})">
          <b-row class="m-0 justify-content-around mt-2 px-2 ">
            <div style="position: relative">

              <b-row style="z-index: 2000">

                <div style="position: relative">
                  <font-awesome-icon class="mx-2" style="font-size: 20px; position: relative" :icon="['fas', 'phone']"/>
                </div>

                <div style="position: relative">
                  <font-awesome-icon v-if="restaurant.enable_online_order" class="mx-2" style="font-size: 20px; position: relative" :icon="['fas', 'mobile']"/>
                </div>

                <div style="position: relative">
                  <font-awesome-icon v-if="restaurant.delivery" class="mx-2" style="font-size: 20px; position: relative" :icon="['fas', 'car-side']"/>
                </div>     

              </b-row>

            </div>
            <p class="mx-2">{{ distance }} km</p>
            <small class="mx-2 d-none d-md-flex">{{ street }}</small>
          </b-row>
        </div>
      </b-col>
      <b-col cols="5" class="p-0 h-100">
        <b-row class="m-0 hover justify-content-end h-100"  @click="$router.push('/my/'+ url).catch(err => {})" v-if="url">
          <div class="outer-preview h-100">
            <div class="middle-preview">
              <b-row class="m-0 justify-content-center" style="flex-direction: column;">
                <div class="text-center">
                  <b-img-lazy :src="img" style="max-height:200px;width: auto;height: auto; " fluid alt="eatDorado Logo"></b-img-lazy>  
                </div>
              </b-row>
            </div>
          </div>
        </b-row>
      </b-col>
    </b-row>

    <b-modal id="infoModal" size="md" v-model="ratingModal" hide-footer hide-header>
      <div class="bg-white" style="border-radius: 10px; transition: all .5s;">
        <b-row class="m-0 p-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <h4 class="ml-2 text-center text-dark" >{{ name }}</h4>
          <font-awesome-icon @click="ratingModal = false" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
        <b-row class="m-0 justify-content-center" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
        <p class="m-0">Bewertungen ({{ratings.length}}):</p>
        </b-row>
        <b-row class="m-0 pb-1 justify-content-center" style="border-top-left-radius: 10px; border-top-right-radius: 10px;" v-if="!ratings">
        aktuell noch keine Bewertungen vorhanden
        </b-row>
        <div class="m-3" v-for="rating in ratings" :key="rating.index">
          <b-row class="m-0 mx-4 justify-content-between">
            <small>{{ rating.sender }}</small>
            <small v-if="rating.date">{{ rating.date | moment('DD.MM.YY HH:mm')}}</small>
          </b-row>
          <p class="m-0 ml-4 mt-2">{{ rating.text }}</p>
          
          <b-form-rating readonly class="hover mb-3 p-0 text-center" size="md" :no-border="true" variant="warning" v-model="rating.rating"></b-form-rating>           
          <hr class="mx-3">
        </div>
            
      </div>
    </b-modal>

  </div>
     
</template>

<script>
// import coreData from '@/mixins/coreDataMixin'

export default {
  name: 'RestaurantRegularComponent',
  // mixins: [coreData],
  props: {
    restaurant: Object,
    name: String,
    img: String,
    description: String,
    distance: String,
    rating: Number,
    id: String,
    init: Boolean,
    url: String,
    ratings: Array,
    street: String,
    city: String
  },
  components: {

  },
  data: () => {
    return {
      ratingModal: false
    }
  },
  watch: {
    
  },
  computed: {
    getRating(){
      var rating = 0.0
      if(!this.ratings) return rating
      this.ratings.forEach(el => {
        rating += el.rating
      })

      return rating / this.ratings.length
    }
  },
  mounted(){
    
  },
  methods: {
    openRatingModal(){
      if(this.ratings.length == 0) return
      this.ratingModal = true
    },
    getOpeningTimes(){
      var timeString = {}
      var date = new Date()
      var day = date.getDay()
      switch (day) {
        case 0:
          if(this.restaurant.opening_times.sunday.start_1 && this.restaurant.opening_times.sunday.end_1){
            timeString.first = this.restaurant.opening_times.sunday.start_1 + ' - ' + this.restaurant.opening_times.sunday.end_1
          }
          if(this.restaurant.opening_times.sunday.start_2 && this.restaurant.opening_times.sunday.end_2){
            timeString.second = this.restaurant.opening_times.sunday.start_2 + ' - ' + this.restaurant.opening_times.sunday.end_2
          }
          return timeString
        case 1:
          if(this.restaurant.opening_times.monday.start_1 && this.restaurant.opening_times.monday.end_1){
            timeString.first = this.restaurant.opening_times.monday.start_1 + ' - ' + this.restaurant.opening_times.monday.end_1
          }
          if(this.restaurant.opening_times.monday.start_2 && this.restaurant.opening_times.monday.end_2){
            timeString.second = this.restaurant.opening_times.monday.start_2 + ' - ' + this.restaurant.opening_times.monday.end_2
          }
          return timeString
        case 2:
          if(this.restaurant.opening_times.tuesday.start_1 && this.restaurant.opening_times.tuesday.end_1){
            timeString.first = this.restaurant.opening_times.tuesday.start_1 + ' - ' + this.restaurant.opening_times.tuesday.end_1
          }
          if(this.restaurant.opening_times.tuesday.start_2 && this.restaurant.opening_times.tuesday.end_2){
            timeString.second = this.restaurant.opening_times.tuesday.start_2 + ' - ' + this.restaurant.opening_times.tuesday.end_2
          }
          return timeString
        case 3:
          if(this.restaurant.opening_times.wednesday.start_1 && this.restaurant.opening_times.wednesday.end_1){
            timeString.first = this.restaurant.opening_times.wednesday.start_1 + ' - ' + this.restaurant.opening_times.wednesday.end_1
          }
          if(this.restaurant.opening_times.wednesday.start_2 && this.restaurant.opening_times.wednesday.end_2){
            timeString.second = this.restaurant.opening_times.wednesday.start_2 + ' - ' + this.restaurant.opening_times.wednesday.end_2
          }
          return timeString
        case 4:
          if(this.restaurant.opening_times.thursday.start_1 && this.restaurant.opening_times.thursday.end_1){
            timeString.first = this.restaurant.opening_times.thursday.start_1 + ' - ' + this.restaurant.opening_times.thursday.end_1
          }
          if(this.restaurant.opening_times.thursday.start_2 && this.restaurant.opening_times.thursday.end_2){
            timeString.second = this.restaurant.opening_times.thursday.start_2 + ' - ' + this.restaurant.opening_times.thursday.end_2
          }
          return timeString
        case 5:
          if(this.restaurant.opening_times.friday.start_1 && this.restaurant.opening_times.friday.end_1){
            timeString.first = this.restaurant.opening_times.friday.start_1 + ' - ' + this.restaurant.opening_times.friday.end_1
          }
          if(this.restaurant.opening_times.friday.start_2 && this.restaurant.opening_times.friday.end_2){
            timeString.second = this.restaurant.opening_times.friday.start_2 + ' - ' + this.restaurant.opening_times.friday.end_2
          }
          return timeString
        case 6:
          if(this.restaurant.opening_times.saturday.start_1 && this.restaurant.opening_times.saturday.end_1){
            timeString.first = this.restaurant.opening_times.saturday.start_1 + ' - ' + this.restaurant.opening_times.saturday.end_1
          }
          if(this.restaurant.opening_times.saturday.start_2 && this.restaurant.opening_times.saturday.end_2){
            timeString.second = this.restaurant.opening_times.saturday.start_2 + ' - ' + this.restaurant.opening_times.saturday.end_2
          }
          return timeString
        default:
          break;
      }
    }
  }
}
</script>

<style lang="scss" >

  .outer-preview {
    display: table;
    position: relative;
    border-bottom-left-radius: 20px;
    border-top-right-radius: 20px;
    top: 0;
    left: 0;
    height: 220px;
    width: 100%;
  }

  .middle-preview {
    display: table-cell;
    vertical-align: middle;
  }

  .inner-preview {
    margin-left: auto;
    margin-right: auto;
  }

  .restaurant-regular {
    border-radius: 20px;
    position: relative;
    height: 220px !important
  }

  .restaurant-details {
    border-bottom-left-radius: 20px;
    border-top-right-radius: 20px;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 35px;
    position: absolute;
  }
  
  .restaurant-rating {
    bottom: 40px;
    left: 0;
    height: 35px;
    position: absolute;

      p {
        margin-top: 10px
      }
  }

  .restaurant-open-times {
    bottom: 55px;
    z-index: 1000;
    left: 18px;
    height: 35px;
    position: absolute;
  }

  .restaurant-distance {
    bottom: 0;
    left: 50%;
    width: 50%;
    height: 35px;
    position: absolute;
  }
</style>
